import { createContext, useContext } from "react";
import { Usuario } from "@/models";

export const UsuarioContext = createContext<Usuario | null>(null);

export const useUsuarioContext = () => useContext(UsuarioContext);
